import React, { useCallback, useState } from 'react'
import { useCreateUser } from 'api'
import { Link } from 'components'
import { RegisterForm } from './RegisterForm'
import { LoginWrapper } from '../LoginWrapper'
import classes from './RegisterPage.module.scss'
import { useTranslation } from 'react-i18next'

export const RegisterPage = () => {
  const { t } = useTranslation()
  const [mutate, { status }] = useCreateUser()
  const [email, setEmail] = useState<string>('')
  const onSubmit = useCallback(
    (values, { setSubmitting }) => {
      mutate({ user: values })
      setEmail(values.email)
      setSubmitting(false)
    },
    [mutate]
  )
  return (
    <LoginWrapper
      title={
        status === 'success' || status === 'failure'
          ? `${t(
              'pages.login.registerPage.registerPage.title.receivedRegistration'
            )}`
          : `${t(
              'pages.login.registerPage.registerPage.title.newRegistration'
            )}`
      }
    >
      {status === 'success' || status === 'failure' ? (
        <>
          <p>
            {t(
              'pages.login.registerPage.registerPage.info.ifRegisterReceived.emailIsSended',
              { email }
            )}
          </p>
          <p>
            {t(
              'pages.login.registerPage.registerPage.info.ifRegisterReceived.clickLinkText'
            )}
          </p>

          <p>
            {t(
              'pages.login.registerPage.registerPage.info.ifRegisterReceived.spamInfo'
            )}
          </p>
        </>
      ) : (
        <>
          <p>{t('pages.login.registerPage.registerPage.info.createAccount')}</p>
          <div className={classes.form}>
            <RegisterForm onSubmit={onSubmit} />
          </div>
        </>
      )}

      <p className={classes.link}>
        <Link to="/login">{t('global.returnToLogin')}</Link>
      </p>
    </LoginWrapper>
  )
}
